/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:05
 * @LastEditors: linxi
 * @LastEditTime: 2023-09-19 09:34:18
 */

import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Table } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import styles from './AnnualCapitalFund.module.css'
import { Columns, LastYearColumns } from './column'
import { Query } from './Query'
import { ThemeContext } from '../../theme/ThemeContext'
import { getDateRange, DateRangeType } from '../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import { getAnnualCapitalFundList } from './AnnualCapitalFundSlice'
interface AnnualCapitalFundProps {
  selectedTab?: any
}

const AnnualCapitalFund = ({
  selectedTab,
}: AnnualCapitalFundProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({})

  const [selectedKeys, setSelectedKeys] = useState<any>([])

  const [natNegoDrugTotalAmount, setNatNegoDrugTotalAmount] = useState<'0.00'>()
  const [natNegoDrugTotalAmountLastTYear, setNatNegoDrugTotalAmountLastTYear] = useState<'0.00'>()

  const [page, setPage] = useState<any>()

  const [pages, setPages] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [showDoctorDetail, setShowDoctorDetail] = useState(false)

  useEffect(() => {
    if (selectedTab == '5') {
      if (params?.startTime) {
        setPageLoading(true)
        getPage()
        getLastYearPage()
        sessionStorage.setItem(
          location.pathname + '_ndrtjjs',
          JSON.stringify({ ...params })
        )
      }
    }
  }, [selectedTab, params])

  const getPage = () => {
    dispatch(getAnnualCapitalFundList({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        setNatNegoDrugTotalAmount(res?.natNegoDrugTotalAmount)
        if (res?.list?.length) {
          setPage(
            res?.list.map((v: any) => {
              return {
                ...v,
                startTime: params?.startTime,
                endTime: params?.endTime,
              }
            })
          )
        } else {
          setPage([])
        }
        setPageLoading(false)
      })
  }

  const getLastYearPage = () => {
    dispatch(
      getAnnualCapitalFundList({
        ...params,
        startTime: moment(params?.startTime)
          ?.subtract(1, 'year')
          .format(DateTimeFormatSimpleOnlyOne),
        endTime: moment(params?.endTime)
          ?.subtract(1, 'year')
          .endOf('day')
          .format(DateTimeFormatSimpleOnlyOne),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
          setNatNegoDrugTotalAmountLastTYear(res?.natNegoDrugTotalAmount)
          if (res?.list?.length) {
          setPages(
            res?.list.map((v: any) => {
              return {
                ...v,
                startTime: moment(params?.startTime)
                  ?.subtract(1, 'year')
                  ?.format(DateTimeFormatSimpleOnlyOne),
                endTime: moment(params?.endTime)
                  ?.subtract(1, 'year')
                  .format(DateTimeFormatSimpleOnlyOne),
              }
            })
          )
        } else {
          setPages([])
        }
        setPageLoading(false)
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  return (
    <Col
      style={{
        backgroundColor: theme.pn,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 10px)',
        overflow: 'hidden',
      }}
    >
      <Query
        loading={pageLoading}
        onValueChange={(v: any) => {
          const paramData = {
            ...params,
            ...v,
            startTime: v?.timeHead
              ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
              : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
            endTime: v?.timeTail
              ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
              : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
            timeHead: undefined,
            timeTail: undefined,
          }
          setParams({
            ...paramData,
          })
        }}
        onChangeShow={(v: any) => {
          setShowDoctorDetail(v)
        }}
      />
        <div className={styles.tableContent} >
          <EditableList
            style={{flex: 1}}
            rowKey={(v, i) => `${i}`}
            loading={pageLoading}
            pagination={false}
            page={{
                current: 1,
                size: 10,
                total: 0,
                items: page,
            }}
            rowClassName={(r: any) =>
                r.xianzhonglx == "合计" ? styles.total : "333"
            }
            columns={Columns(page?.size * (page?.current - 1), showDoctorDetail)}
            onChangePage={(current, size) => {
                setParams({
                    ...params,
                    current,
                    size,
                })
            }}
          />
          <div style={{position: 'absolute',left: 0}}>国谈药品医保结算总金额：{natNegoDrugTotalAmount}</div>
        </div>
        <div style={{ marginTop: '50px' }}>前一年同期数据</div>
        <div className={styles.tableContent} >
          <EditableList
            style={{flex: 1}}
            rowKey={(v, i) => `${i}`}
            loading={pageLoading}
            pagination={false}
            page={{
                current: 1,
                size: 10,
                total: 0,
                items: pages,
            }}
            rowClassName={(r: any) =>
                r.xianzhonglx == "合计" ? styles.total : "333"
            }
            columns={LastYearColumns(params, pages?.size * (pages?.current - 1), showDoctorDetail)}
            onChangePage={(current, size) => {
                setParams({
                    ...params,
                    current,
                    size,
                })
            }}
          />
         <div style={{position: 'absolute',left: 0}}>国谈药品医保结算总金额：{natNegoDrugTotalAmountLastTYear}</div>
        </div>
    </Col>
  )
}

export const AnnualCapitalFunds = forwardRef(AnnualCapitalFund)
